import { useNotificationStore } from '../../store/notificationStore';
import { useExtensionStore } from '../store';

/**
 * `ui.notify` from an extension → an app notification.
 *
 * Extension frames are invisible (ExtensionHostLayer), so anything an
 * extension writes on its own page — "Drop failed: …", "Table created" —
 * reached nobody (found 30.09.2026: the DB Manager's errors, Show CREATE and
 * Design table all "did nothing"). This is the one way such a message gets
 * on screen.
 *
 * Kept narrow on purpose: plain text only (notifications render text, never
 * HTML), capped length, a fixed set of tones, and the TITLE is always the
 * extension's own name — an extension cannot make its message look like it
 * came from the app itself.
 */
const TONES = new Set(['info', 'success', 'warning', 'error']);
export const NOTIFY_MAX_CHARS = 400;

export function notifyFromExtension(extensionId, params) {
  const raw = typeof params?.message === 'string' ? params.message : '';
  const message = raw.length > NOTIFY_MAX_CHARS ? `${raw.slice(0, NOTIFY_MAX_CHARS - 1)}…` : raw;
  if (!message.trim()) return false;
  const tone = TONES.has(params?.tone) ? params.tone : 'info';
  const name = useExtensionStore.getState().extensions?.[extensionId]?.name || 'Extension';
  useNotificationStore.getState().addNotification({
    type: tone,
    title: name,
    message,
    ...(tone === 'error' ? { duration: 7000 } : {}),
  });
  return true;
}
